import type { Theme } from '../../types/theme';

export const notionTheme: Theme = {
  id: 'notion',
  name: 'Notion',
  description: 'Warm minimalism with soft surfaces and document-like feel. Near-black text on pure white.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/notion/DESIGN.md',
  visualKeywords: ['warm', 'minimal', 'document', 'soft surfaces', 'blue accent', 'paper-like'],
  colors: {
    background: '#ffffff',
    surface: '#f6f5f4',
    surfaceElevated: '#ffffff',
    surfaceDark: '#31302e',
    textPrimary: 'rgba(0,0,0,0.95)',
    textSecondary: '#3f3f3f',
    textMuted: '#a39e98',
    border: 'rgba(0,0,0,0.1)',
    borderSubtle: 'rgba(0,0,0,0.05)',
    primary: '#0075de',
    primaryHover: '#0055b3',
    primaryActive: '#004494',
    accent: '#2a9d99',
    onPrimary: '#ffffff',
    success: '#1aae39',
    warning: '#dd5b00',
    error: '#c13515',
  },
  typography: {
    headingFont: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    bodyFont: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    monoFont: '"JetBrains Mono", monospace',
    headingWeight: '700',
    bodyWeight: '400',
    letterSpacingHeading: '-1.5px',
    letterSpacingBody: '0',
  },
  radius: {
    button: '4px',
    card: '12px',
    panel: '16px',
    badge: '9999px',
    input: '4px',
  },
  shadow: {
    card: '0 4px 18px rgba(0,0,0,0.04), 0 2px 7px rgba(0,0,0,0.02)',
    elevated: '0 8px 28px rgba(0,0,0,0.05), 0 4px 14px rgba(0,0,0,0.03)',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '1200px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '52px',
  },
  mood: {
    density: 'medium',
    tone: 'warm, approachable, workspace-focused',
    productFit: ['Productivity tools', 'Documentation', 'Wikis', 'Team workspaces'],
    bestFor: ['Note-taking', 'Team collaboration', 'Knowledge management', 'Documentation'],
    notGoodFor: ['Real-time apps', 'Data dashboards', 'High-density information'],
  },
};
